module.exports = __webpack_public_path__ + "2bab5bdf553025a6d47ad739eb1704db.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/bg_line_pattern.png
// module id = 190
// module chunks = 0